import { html } from 'lit-element';
import { ifNotNull } from '../../utils/directives';
import {
  KatalComponent,
  KatLitElement,
  coerceToArray,
} from '../../shared/base';
import { trimmedHtml } from '../../shared/trimmed-html';

/**
 * @component {kat-breadcrumb} KatalBreadcrumb Breadcrumbs is a graphical control element used as a navigational aid in user interfaces. It allows users to keep track of their locations within websites.
 * @guideline Breadcrumbs should always appear at the top of a page.
 * @guideline Do Use either the "items" property or "kat-breadcrumb-item" children, but not both.
 * @guideline Dont It is not recommended to use breadcrumbs in multiple places on a page or in the middle of a page.
 * @contentProvided This is to let users know the components expects in inner html to be completed
 * @example SetViaJson {"items": [{"label":"Parent", "href":"#"}, {"label":"Group", "href":"#"},{"label":"Category", "href":"#"},{"label":"Current Category", "href":"#"}], "content":""}
 * @example SetViaHtml {"content": "<kat-breadcrumb-item label=\"Parent\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Group\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Category\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Current Category\" href=\"#\"></kat-breadcrumb-item>"}
 * @status Production
 * @theme flo
 */
class KatalBreadcrumb extends KatLitElement {
  static get properties() {
    return {
      /** @classprop {json} items The array of breadcrumb group items */
      items: { type: Array },
    };
  }

  // disable shadow-dom
  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
  }

  get items() {
    return this._items;
  }

  /**
   * @deprecated
   * This logic will be removed in 1.3
   */
  set items(val) {
    const oldVal = this._items;
    this._items = coerceToArray(this, 'items', val);
    this.requestUpdate('items', oldVal);
  }

  render() {
    if (!this._items) {
      // Skip render if no items are given so we don't blow away light dom
      // elements. We won't need this after shadow dom changes
      return;
    }

    return html`
      ${this._items.map(
        item => trimmedHtml`
          <kat-breadcrumb-item
            label=${ifNotNull(item.label)}
            href=${ifNotNull(item.href)}
          ></kat-breadcrumb-item>
        `
      )}
    `;
  }
}

/**
 *
 */
class KatalBreadcrumbItem extends KatLitElement {
  static get properties() {
    return {
      label: { type: String, reflect: true },
      href: { type: String, reflect: true },
    };
  }

  // disable shadow-dom
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <span last>${this.label}</span>
      <kat-link middle href="${this.href}" label="${this.label}"></kat-link>
      <kat-icon middle name="chevron-right" size="small"></kat-icon>
    `;
  }
}

KatalComponent.register('kat-breadcrumb', KatalBreadcrumb);
KatalComponent.register('kat-breadcrumb-item', KatalBreadcrumbItem);
